module.exports = __webpack_public_path__ + "img/0Q3B0162_L_Foamcore.08a48ab3.jpg";